import * as React from 'react';

import styled from 'styled-components';
import { ReactNode } from 'react';
import { GraphsMenuItem } from './GraphsMenuItem';
import { SidebarTrigger } from '@/components/ui/sidebar';

const TopBarContainer = styled.div`
    display: grid;

    background-color: ${props => props.theme.backgroundColor};
    border-bottom: 1px solid ${props => props.theme.separatorColor};
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 8px;
    padding-left: 8px;

    grid-template-columns: auto 1fr auto;
    grid-template-rows: 100%;
    grid-template-areas: 'menu center right';
`;

const Menu = styled.div`
    grid-area: menu;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CenterSection = styled.div`
    grid-area: center;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const RightSection = styled.div`
    grid-area: right;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
`;

interface Props {
    className?: string;
    renderLeftExtra?: () => ReactNode;
    renderCenter?: () => ReactNode;
    renderRightSection?: () => ReactNode;
    showSidebarTrigger?: boolean;
}

export const TopBar: React.FC<Props> = ({
    renderLeftExtra,
    renderCenter,
    renderRightSection,
    className = '',
    showSidebarTrigger = true,
}) => {
    return (
        <TopBarContainer className={className}>
            <Menu>
                {showSidebarTrigger && <SidebarTrigger />}
                <GraphsMenuItem to={'/'} />
                {renderLeftExtra && renderLeftExtra()}
            </Menu>
            <CenterSection>{renderCenter && renderCenter()}</CenterSection>
            <RightSection>{renderRightSection && renderRightSection()}</RightSection>
        </TopBarContainer>
    );
};
